module.exports = __webpack_public_path__ + "img/Bear37.c78db76e.jpg";